"use client";

import { Card } from "@/components/ui/card";

import { cn } from "@/lib/utils";

export function RewardAverageCard({
  color,
  cryptoName,
  cryptoSymbol,
  percentage,
  usdAmount,
}: {
  color: string;
  cryptoName: string;
  cryptoSymbol: string;
  percentage: number;
  usdAmount: number;
}) {
  return (
    <Card className="bg-transparent px-3.5 py-3">
      <div className="mb-2 flex items-center gap-2">
        <div className={cn("h-3 w-0.5 rounded-xl", color)} />
        <div className="text-sm font-medium text-white">
          {cryptoName} <span className="text-foreground">({cryptoSymbol})</span>
        </div>
      </div>
      <div className="flex items-center gap-3 pl-3 text-xs">
        <div className="text-foreground">{percentage}% APR</div>
        <div className="bg-accent size-1 rounded-full" />
        <div className="text-success">
          {new Intl.NumberFormat("en-US").format(usdAmount)}
          &nbsp;USD
        </div>
      </div>
    </Card>
  );
}
